import React from "react";

const FooterComponent = () => {
    return (
        <footer className="footer">
            <div className="tnc">
                Bumbu Nicolae, &#x24B8; 2020
            </div>
        </footer>
    )
};

export default FooterComponent;